var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.95,5.76c.07-.17.07-.36,0-.53-.03-.07-.07-.13-.12-.18-.01-.01-.02-.03-.03-.04L103.99.2c-.27-.27-.7-.27-.97,0-.27.27-.27.7,0,.97l3.64,3.64H.69c-.38,0-.69.31-.69.69s.31.69.69.69h105.97l-3.64,3.64c-.27.27-.27.7,0,.97.27.27.7.27.97,0l4.81-4.81s.02-.03.03-.04c.05-.05.09-.11.12-.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/white-arrow.cffd9cdce1b624be559c94d0a67f0be1.svg";
export { ForwardRef as ReactComponent };